import './login.css';
import { Link, useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { useUserAuth } from './userAuthContext';
import Logo from '../logo/Logo';
import { UsernameContext } from './usernameContext';
export default function LoginPage(){
    const {username, setUsername} = useContext(UsernameContext);
    const [email, setEmail] = useState("");
    const [password,setPassword] = useState("");
    const {signIn} = useUserAuth();
    const [error, setErr] = useState("");
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        try {
            await(signIn(email, password));
            if(localStorage.getItem('userlists')){
                const tempArr = JSON.parse(localStorage.getItem('userlists'));
                setUsername(tempArr[0][email]);
            }
            navigate('/');
        }catch(err) {
            setErr(err.message);
        }
    }
    return (
        <>
            <div className="login-body">
                <div className="login-flex">
                    <div className='login-img2'>
                    </div>
                    <div className='login-img'>
                        <img src="https://www.travelsiteindia.com/blog/wp-content/uploads/2017/10/flora-and-fauna-of-kerala.jpg" height='600px'/>
                    </div>
                    <div className='login-box'>
                        <div className='logo-box2'>
                            <Logo />
                        </div>
                        <div className="login-content">
                           <form onSubmit={handleSubmit}>
                                <label htmlFor="user-email">Enter your email</label>
                                <input type="text" id="user-email" placeholder="Enter email" className='logUser' onChange={(e)=>setEmail(e.target.value)} />
                                <label htmlFor="userPass">Enter password</label>
                                <input type="password" id="userPass" placeholder="Enter password" className='logUser' onChange={(e)=>setPassword(e.target.value)} />
                                <br />
                                <button type='submit' id='logSubmit'>Login</button>
                           </form>
                        </div>
                        <div style={{marginTop:'10px'}} className='new-user'>
                            <p style={{color:'orange'}}>Create an account? <Link to="/signup" style={{color:"white", textDecoration:'underline', }} className='linked'>Sign Up</Link></p>
                            <p style={{color:'red', textAlign:'center'}}>{error}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}